import { map, filter, share, switchMap, mergeMap, 
  combineLatest, startWith, debounceTime, delay, tap } from 'rxjs/operators'
import { from, of } from 'rxjs'
import _ from 'lodash'

import { gql } from 'apollo-boost';

import client from '../apollo';
import { Dispatch } from 'architecture'
import * as Rx from 'rxjs';

const UPLOAD_FILE = gql`
  mutation upsertFileInstance($object: String, $tags: [String!], $name: String, $file: Upload!) {
    upsertFileInstance(object: $object, tags: $tags, name: $name, file: $file) {
      success
    }
  }
`;
// Open Modal
// Dispatch.getAction('samples', 'upload')
//   .subscribe(e => Dispatch.nextAction('modal', 'open', 'Uploader'))

Dispatch.getAction('upload', 'file')
  .pipe(
    switchMap(file => from(client.mutate({
        mutation: UPLOAD_FILE,
        variables: { file }
      }))
      .pipe(
        map(f => f.data.upsertFileInstance.success ? 'success' : 'error'),
        mergeMap(state => of('none')
          .pipe(
            delay(3000),
            startWith(state)
          ),
        ),
        startWith('loading')
      )
    ),
    startWith('none')
  )
  .subscribe(e => Dispatch.mergeState('upload', { state: e }))